import { render, staticRenderFns } from "./DraggableTabs.vue?vue&type=template&id=1b41c2d6"
import script from "./DraggableTabs.vue?vue&type=script&lang=js"
export * from "./DraggableTabs.vue?vue&type=script&lang=js"
import style0 from "./DraggableTabs.vue?vue&type=style&index=0&id=1b41c2d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports